import * as React from 'react'

import { Text } from '@factorialco/deprecated-design-system'

import formatCurrency from 'modules/core/lib/formatCurrency'
import { currencyToNumber } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'

import Salary from 'modules/payroll_bundle/components/common/components/Salary'

interface Props {
  amount: string
  errorLabel?: string
  previousValue?: string
}

const ShowAmount = ({ amount, errorLabel, previousValue }: Props) => {
  const generateLabel = () => {
    const trimmedPreviousValue = String(previousValue).trim()
    const trimmedCurrentValue = String(amount).trim()
    const previousValueInLocal = formatCurrency(currencyToNumber(trimmedPreviousValue) * 100)
    const currentValueInLocal = formatCurrency(currencyToNumber(trimmedCurrentValue) * 100)

    return (
      <>
        <Text.Normal weight="medium" stroked>
          {previousValueInLocal}
        </Text.Normal>{' '}
        - <Text.Normal weight="medium">{currentValueInLocal}</Text.Normal>
      </>
    )
  }

  const updateLabel = previousValue ? generateLabel() : null

  if (!amount) {
    return (
      <Text.Normal weight="medium" color="grey600">
        {i18n.t('payroll_bundle.payroll_results.not_imported')}
      </Text.Normal>
    )
  }

  return <Salary salary={amount} label={errorLabel} updateLabel={updateLabel} />
}

export default ShowAmount
